import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { getIsDesignPatent } from '../../utils/get-is-design-patent';
import { PATENT_VALUATION_LEVELS } from '../../constants';
import type { PatentValuationExtend } from '../../types';
import type { GetPatentValuationDTO } from '../get-patent-valuation';

const MIN_VALUATION_LEVEL = 0;

@injectable()
export class GetPatentValuationDTOImpl implements GetPatentValuationDTO {
    private _calculatePatentValuationLevel(value: number) {
        for (let index = 0; index < PATENT_VALUATION_LEVELS.length; index++) {
            const { min, max, level } = PATENT_VALUATION_LEVELS[index];
            if (min < value && max >= value) return level;
        }
        return MIN_VALUATION_LEVEL;
    }

    private _getFormattedValuation(valuation: number) {
        return `$ ${valuation.toLocaleString()}`;
    }

    public getPatentValuation(valuation: number, patentType: string[]) {
        const valuationData: PatentValuationExtend = {
            isNoValuation: true,
            valuation: '',
        };

        try {
            // 外观专利不展示专利价值
            const isDesignPatent = getIsDesignPatent(patentType);
            valuationData.isNoValuation = isDesignPatent;

            if (isDesignPatent) return valuationData;

            const level = this._calculatePatentValuationLevel(valuation);
            if (level > MIN_VALUATION_LEVEL) {
                valuationData.valuation = this._getFormattedValuation(valuation);
                valuationData.patent_value_levels = level;
            }
        } catch (error) {
            console.error(error);
        }

        return valuationData;
    }
}
